import React, { useContext } from 'react'
import { Navigate } from 'react-router-dom'
import { useTenant } from '../../contexts/TenantContext'
import { getModulesForTenant } from '../../config/modulesByTenant'
import UserContext from '../../contexts/UserContext'

interface TenantGuardProps {
  children: React.ReactNode
  requiredTenant?: 'Aco' | 'fashion' | ('Aco' | 'fashion')[]
  requiredPath?: string
}

const TenantGuard: React.FC<TenantGuardProps> = ({ children, requiredTenant, requiredPath }) => {
  const { tenantId } = useTenant()
  const { token, user } = useContext(UserContext)

  if (token && tenantId === null) {
    return null
  }

  if (token && (!user || !user.id && !user.sub)) {
    return null
  }

  if (requiredTenant) {
    const hasAccess = () => {
      if (Array.isArray(requiredTenant)) {
        return requiredTenant.some(tenant => {
          if (tenant === 'Aco') {
            return tenantId !== 2
          } else if (tenant === 'fashion') {
            return tenantId === 2
          }
          return false
        })
      }

      if (requiredTenant === 'Aco') {
        return tenantId !== 2
      } else if (requiredTenant === 'fashion') {
        return tenantId === 2
      }
      return false
    }

    if (!hasAccess()) {
      return (
        <div style={{
          padding: '20px',
          textAlign: 'center',
          color: '#666',
          fontSize: '16px'
        }}>
          <h3>Acesso Restrito</h3>
          <p>Você não tem permissão para acessar este módulo.</p>
          <p>Este módulo é específico para tenant: {Array.isArray(requiredTenant) ? requiredTenant.join(', ') : requiredTenant}</p>
        </div>
      )
    }

    return <>{children}</>
  }

  if (requiredPath) {
    const availableModules = getModulesForTenant(tenantId)
    const hasAccess = availableModules.some(module => module.path === requiredPath)

    if (!hasAccess) {
      return <Navigate to="/panel" replace />
    }

    return <>{children}</>
  }

  return <>{children}</>
}

export default TenantGuard